module.exports = require('ember-number-field').extend({
    format: '0,0.00'
});
